import React from "react"
import Conditional from "@/components/core/Conditional/Conditional"
import GridView from "@/components/PartsViewer/v2/GridAndListPanel/GridView"
import ListView from "@/components/PartsViewer/v2/GridAndListPanel/ListView"

const ViewController = props => {
  const {
    partController,
    isListView,
    isListExtend,
    showPopup,
    visibleData,
    title,
    sku,
    showCart,
    setShowCart,
    showCartPopUp,
    selectedFile,
    siteName,
  } = props || {}
  return (
    <>
      <Conditional show={isListView}>
        {partController?.actions?.get?.firstEntries(visibleData)?.map(input => (
          <ListView
            key={input.key}
            dataInput={input}
            dataPromise={input.ctApiPromise}
            showPopup={showPopup}
            isListExtend={isListExtend}
            title={title}
            sku={sku}
            showCart={showCart}
            setShowCart={setShowCart}
            showCartPopUp={showCartPopUp}
            selectedFile={selectedFile}
            siteName={siteName}
          />
        ))}
      </Conditional>
      <Conditional show={!isListView}>
        {partController?.actions?.get?.firstEntries(visibleData)?.map(input => (
          <GridView
            key={input.key}
            dataInput={input}
            dataPromise={input.ctApiPromise}
            showPopup={showPopup}
            isListExtend={isListExtend}
            title={title}
            sku={sku}
            showCart={showCart}
            setShowCart={setShowCart}
            showCartPopUp={showCartPopUp}
            selectedFile={selectedFile}
            siteName={siteName}
          />
        ))}
      </Conditional>
    </>
  )
}

export default ViewController
